import { ApiService } from "./api.service";

export const USER_ROLE = {
    SUPER_USER: "SuperUser",
    POWER_USER: "PowerUser",
    CONTRACTOR: "Contractor",
    COP_EMPLOYEE: "CopEmployee",
    PERSON_IN_CHARGE: "PersonInCharge",
    COP_CONTRACTOR_DESIGNEE: "CopContractorDesignee",
};

// Roles limited to the Job Safety section only
export const RESTRICTED_ROLES: string[] = [
    USER_ROLE.CONTRACTOR,
    USER_ROLE.COP_EMPLOYEE,
    USER_ROLE.PERSON_IN_CHARGE,
    USER_ROLE.COP_CONTRACTOR_DESIGNEE,
];
// Decodes a JWT's payload segment without pulling in a decoding library --
// this only ever reads the token this same app issued to itself, purely to
// know when to proactively clear a stale/expired session client-side. It is
// NOT a security boundary (a user can always edit sessionStorage directly);
// the server is and must remain the source of truth for authorization.
const decodeJwtPayload = (token: string): any => {
    try {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const json = decodeURIComponent(
            atob(base64)
                .split("")
                .map((c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0"))
                .join("")
        );
        return JSON.parse(json);
    } catch {
        return null;
    }
};

const isTokenExpired = (token: string): boolean => {
    const payload = decodeJwtPayload(token);
    if (!payload || !payload.exp) return false; // can't decode -- don't block login on an unrelated parsing issue
    return Date.now() >= payload.exp * 1000;
};

export class AuthService {
    isAuthenticated() {
        const token = sessionStorage.getItem("token");
        if (!token) return false;
        if (isTokenExpired(token)) {
            // Session outlived the token -- clear it so the app doesn't keep
            // treating this as a logged-in session until an API call happens
            // to fail.
            this.logout();
            return false;
        }
        return true;
    }

    isSuperUser() {
        return sessionStorage.getItem("role") === USER_ROLE.SUPER_USER;
    }

    getUser() {
        return {
            userName: sessionStorage.getItem("name"),
            userRole: sessionStorage.getItem("role"),
            userId: sessionStorage.getItem("id"),
        };
    }

    async login({ email, password,otp }: any) {
        return new Promise((resolve, reject) => {
            const request = {
                username: email,
                password,
                otp
            };
            ApiService.post("Account/authenticate", JSON.stringify(request))
                .then((result) => {
                    if (result && result.token) {
                            sessionStorage.setItem("name", result.name);
                            sessionStorage.setItem("role", result.role);
                            sessionStorage.setItem("id", result.id);
                            sessionStorage.setItem("token", result.token);
                            resolve(result);
                    
                    } else {
                        reject(result);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                });
        });
    }

    logout() {
        return new Promise((resolve) => {
            // fake promise need to be hit the api to delete the user token from backend
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("name");
            sessionStorage.removeItem("role");
            sessionStorage.removeItem("id");
            sessionStorage.removeItem("otp");
            resolve({ status: 200 });
        });
    }

    async forgotPassword({ email }: any) {
        return new Promise((resolve, reject) => {
            const request = {
                email
            };
            ApiService.post("Account/forgot-password-otp", JSON.stringify(request))
                .then((result) => {
                    if (result) {                        
                        resolve(result);
                    } else {
                        reject(result);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                });
        });
    }


    async changePassword({name, email,password, otp }: any) {
        return new Promise((resolve, reject) => {
            const request = {
                name,
                email,
                password,
                otp
            };
            ApiService.post("Account/change-password", JSON.stringify(request))
                .then((result) => {
                    if (result) { 
                        resolve(result);
                    } else {
                        reject(result);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                });

        });
    }
}
